// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"_cb7e9c8f","count":"_5efe7d58","term":"_7b68c295","returnToAll":"_abfb406b"};